"use strict";

module.exports = 'M12,17.5l6.8,4.9l-2.6-8L23,9.5h-8.4l-2.6-8l-2.6,8H1l6.8,4.9l-2.6,8L12,17.5';